import { CanonicalLoad } from '@numeo/types-core'

/** Returns a unique string identifier for a load, safe for loads with id=-1 (ARRIVE/BEON/NAVISPHERE) */
export const getLoadUid = (load: CanonicalLoad): string => load.externalId || `${load.sourceType}-${load.id}`
